import { orderBy } from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import ActivitiesLog from "shared/components/ActivitiesLog";
import Loading from "shared/components/Spin";
import { NAME_SPACES } from "shared/locales/constants";
import { ACTIVITY_FILTERS } from "utils/constants";
import { ensureUtcDate } from "utils/helpers/date";

const SubscriptionActivities = ({
  isPageLoading,
  qualificationActivities,
  statusActivities,
  callActivities,
  emailActivities,
  hasMoreCalls,
  handleLoadMoreCalls,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTACT);
  const [activeFilter, setActiveFilter] = useState(ACTIVITY_FILTERS.ALL);

  const filters = [
    { key: ACTIVITY_FILTERS.ALL, label: t("ACTIVITIES.FILTERS.ALL") },
    { key: ACTIVITY_FILTERS.CALLS, label: t("ACTIVITIES.FILTERS.CALLS") },
    {
      key: ACTIVITY_FILTERS.QUALIFICATIONS,
      label: t("ACTIVITIES.FILTERS.QUALIFICATIONS"),
    },
    {
      key: ACTIVITY_FILTERS.STATUSES,
      label: t("ACTIVITIES.FILTERS.STATUSES"),
    },
    { key: ACTIVITY_FILTERS.EMAILS, label: t("ACTIVITIES.FILTERS.EMAILS") },
  ];

  if (isPageLoading) {
    return <Loading />;
  }

  let filtered = [];
  if (activeFilter === ACTIVITY_FILTERS.ALL) {
    filtered = [
      ...qualificationActivities,
      ...statusActivities,
      ...callActivities,
      ...emailActivities,
    ];
  } else if (activeFilter === ACTIVITY_FILTERS.CALLS) {
    filtered = callActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.QUALIFICATIONS) {
    filtered = qualificationActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.STATUSES) {
    filtered = statusActivities;
  } else if (activeFilter === ACTIVITY_FILTERS.EMAILS) {
    filtered = emailActivities;
  }

  const activities = orderBy(
    filtered,
    (activity) => {
      const date = ensureUtcDate(activity.date);
      const time = date.getTime();
      return Number.isNaN(time) ? 0 : time;
    },
    "desc",
  );

  return (
    <div className="activities-tab">
      <div className="activities-tab__filters">
        {filters.map(({ key, label }) => (
          <button
            key={key}
            className={classNames("activities-tab__filter", {
              "activities-tab__filter--active": activeFilter === key,
            })}
            onClick={() => setActiveFilter(key)}
          >
            {label}
          </button>
        ))}
      </div>
      {!activities.length ? (
        <div className="no-activity">{t("ACTIVITIES.NO_ACTIVITY")}</div>
      ) : (
        <ActivitiesLog
          activities={activities}
          hasMore={hasMoreCalls}
          onLoadMore={handleLoadMoreCalls}
        />
      )}
    </div>
  );
};

SubscriptionActivities.propTypes = {
  isPageLoading: PropTypes.bool,
  qualificationActivities: PropTypes.array,
  statusActivities: PropTypes.array,
  callActivities: PropTypes.array,
  emailActivities: PropTypes.array,
  hasMoreCalls: PropTypes.bool,
  handleLoadMoreCalls: PropTypes.func,
};

SubscriptionActivities.defaultProps = {
  isPageLoading: false,
  qualificationActivities: [],
  statusActivities: [],
  callActivities: [],
  emailActivities: [],
  hasMoreCalls: false,
  handleLoadMoreCalls: () => {},
};

export default SubscriptionActivities;
